import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

@ModuleName("Fiscalisation_RO")
export class Fiscalisation_RO implements AxInit {
    private _defaultCnp: string = '0000000000000';
    private _defaultTin: string = 'RO00000000';
    private _parentId: string = '[data-fiscal-ro]';
    private _hasData: boolean = false;
    private _validateUrl: string = '/Fiscalisation/Validate';
    private _submitUrl: string = '/Fiscalisation/Continue';
    private _loadStatesDataUrl: string = '/Fiscalisation/GetSubDivisions';
    private _loadPersonDataUrl: string = '/Fiscalisation/GetPersonData';
    private _validClass: string = 'wtp-validation-valid';
    private _invalidClass: string = 'wtp-validation-unvalid';
    constructor(private axLoading = new AxLoading()) { }

    AxInit(init: InitFiscalisationData) {
        //Select events
        $(this._parentId).on('change', '[data-PersonType-select]', (e) => this.ManagePersonType(e));
        $(this._parentId).on('change', '[data-CountryCode-select]', (e, stateCode) => this.ManageCoutryCode(e, stateCode));
        $(this._parentId).on('change', '[data-StateCode-select]', (e) => this.ManageStateCode(e));
        //Checkbox events
        $(this._parentId).on('change', '#SetNonResident', (e) => this.ManageSetNonResident(e));
        //Button events
        $('[data-fiscal-continue-button]').on('click', () => this.ManageContinueButton());
        $('[data-check-vat-code-button]').on('click', () => this.ManageCheckButton());
        this.LoadOrPopulateData(init);
    }

    LoadOrPopulateData(init: InitFiscalisationData) {
        this._hasData = this.CheckFiscalisationModelDefaultValues(init.fiscalisationData) || init.hasAccount;
        if (this.CheckFiscalisationModelDefaultValues(init.fiscalisationData)) {
            this.FillFieldsFromFiscalisationModel(init.fiscalisationData);
        }
        else {
            if (init.hasAccount) {
                this.LoadAccountData();
            }
        }
    }

    LoadAccountData() {
        this.axLoading.ShowLoadingIndicator($(this._parentId)?.get(0));
        AxessViewer.loadPartialView(this._loadPersonDataUrl, null,
            (res) => {
                this.axLoading.HideLoadingIndicator($(this._parentId)?.get(0));
                if (res.success) {
                    this.FillFieldsFromPersonData(res.person);
                    //Assuming account type is always PersonType.Person
                    $('[data-PersonType-select]').val(PersonType.Person.toString()).trigger('change');
                }
                $('.fiscal-data-portlet__head__error').html(res.success ? '' : res.errorMsg);
            },
            { contentType: 'application/json', addCulturInfo: true, silent: true }
        );
    }

    FillFieldsFromPersonData(personData) {
        if (personData != null) {
            $('#VatCode').val(personData.ExtPersonId);
            $('#FirstName').val(personData.Firstname);
            $('#LastName').val(personData.Lastname);
            $('#CompanyName').val(personData.Firstname);
            $('#Email').val(personData.Email);
            $('#Address').val(personData.Street);
            $('#City').val(personData.City);
            $('#ZipCode').val(personData.ZipCode);
            $('[data-CountryCode-select]').val(personData.CountryCode).trigger('change', personData.State);
            $('[data-PersonType-select]').val(PersonType.Person.toString()).trigger('change');
        }
    }

    CheckFiscalisationModelDefaultValues(fiscalisationData) {
        return fiscalisationData?.FiscalisationPayer?.PayerVatCode
            && fiscalisationData?.FiscalisationPayer?.PayerFirstName
            && fiscalisationData?.FiscalisationPayer?.PayerLastName
            && fiscalisationData?.FiscalisationPayer?.PayerEmail
            && fiscalisationData?.FiscalAddress?.Address
            && fiscalisationData?.FiscalAddress?.City
            && fiscalisationData?.FiscalAddress?.ZipCode
            && fiscalisationData?.FiscalAddress?.CountryCode
            && fiscalisationData?.FiscalAddress?.SubDivisionCode
    }

    FillFieldsFromFiscalisationModel(fiscalisationData) {
        if (fiscalisationData != null) {
            $('#VatCode').val(fiscalisationData.FiscalisationPayer.PayerVatCode);
            $('#FirstName').val(fiscalisationData.FiscalisationPayer.PayerFirstName);
            $('#LastName').val(fiscalisationData.FiscalisationPayer.PayerLastName);
            $('#CompanyName').val(fiscalisationData.FiscalisationPayer.PayerFirstName);
            $('#Email').val(fiscalisationData.FiscalisationPayer.PayerEmail);
            $('#Address').val(fiscalisationData.FiscalAddress.Address);
            $('#City').val(fiscalisationData.FiscalAddress.City);
            $('#ZipCode').val(fiscalisationData.FiscalAddress.ZipCode);
            $('[data-CountryCode-select]').val(fiscalisationData.FiscalAddress.CountryCode).trigger('change', fiscalisationData.FiscalAddress.SubDivisionCode);
            $('[data-PersonType-select]').val(fiscalisationData.FiscalisationPayer.PayerType.toString() === '0'
                ? PersonType.Person.toString()
                : PersonType.Company.toString()).trigger('change');
        }
    }

    /// Visible rows: [data-vat-code-inputs] [data-address-inputs] [data-miscelanea-inputs]
    /// Conditional visible rows (depends on personType): [data-person-inputs] [data-company-inputs]
    RenderDataInputsVisibleByPersonType(personType) {
        switch (personType) {
            case PersonType.Person.toString():
                $('[data-person-inputs]').removeClass('d-none');
                $('[data-company-inputs]').addClass('d-none');
                break;
            case PersonType.Company.toString():
                $('[data-company-inputs]').removeClass('d-none');
                $('[data-person-inputs]').addClass('d-none');
                break;
        }
        $('[data-vat-code-inputs]').removeClass('d-none');
        $('[data-address-inputs]').removeClass('d-none');
        $('[data-miscelanea-inputs]').removeClass('d-none');
    }

    /// Visible rows: [data-vat-code-inputs]
    /// Hidden rows: [data-person-inputs] [data-company-inputs] [data-address-inputs] [data-miscelanea-inputs]
    RenderOnlyVatCodeVisible() {
        $('[data-vat-code-inputs]').removeClass('d-none');
        $('[data-person-inputs]').addClass('d-none');
        $('[data-company-inputs]').addClass('d-none');
        $('[data-address-inputs]').addClass('d-none');
        $('[data-miscelanea-inputs]').addClass('d-none');
    }

    RenderDataInputsHidden() {
        $('[data-vat-code-inputs]').addClass('d-none');
        $('[data-person-inputs]').addClass('d-none');
        $('[data-company-inputs]').addClass('d-none');
        $('[data-address-inputs]').addClass('d-none');
        $('[data-miscelanea-inputs]').addClass('d-none');
    }

    ManageRenderInputDivs(viewAllRows: boolean) {
        const personType = $('#PersonType').val();

        //All rows hidden if no personType selected.
        if (personType === '') {
            this.RenderDataInputsHidden();
            this.ManagePortletHeaderInfo(true, null);
        }
        else {
            if (viewAllRows) {
                this.RenderDataInputsVisibleByPersonType(personType);
            }
            else {
                this.RenderOnlyVatCodeVisible();
            }
        }
    }

    ManagePersonType(e) {
        this.CleanValidators();
        const selectedValue = e.currentTarget.value;
        const element = $(e.currentTarget).find(`option[value="${selectedValue}"]`);
        element.attr('selected', 'selected');

        $('#PersonType').val(selectedValue);
        $('#PersonTypeText').val(element.text().trim());

        switch (selectedValue) {
            case PersonType.Person.toString():
                $('#SetNonResident').removeAttr('disabled');
                $("#VatCode").attr('placeholder', this._defaultCnp)
                break;
            case PersonType.Company.toString():
                $('#SetNonResident').attr('disabled', 'disabled');
                $("#VatCode").attr('placeholder', this._defaultTin)
                break;
        }

        this.ManageRenderInputDivs(this._hasData);
    }

    ManageCoutryCode(e, stateCode) {
        const selectedValue = e.currentTarget.value;
        const element = $(e.currentTarget).find(`option[value="${selectedValue}"]`);
        element.attr('selected', 'selected');

        $('#CountryCode').val(selectedValue);
        $('#CountryCodeText').val(element.text().trim());

        if (selectedValue == '') {
            $('[data-StateCode-select]').val('').trigger('change');
            return;
        }

        this.LoadStates(selectedValue, stateCode);
    }

    LoadStates(countryCode, stateCode) {
        AxessViewer.loadPartialView(this._loadStatesDataUrl,
            JSON.stringify({ countryCode: countryCode }),
            (res) => {
                this.axLoading.HideLoadingIndicator($(this._parentId)?.get(0));
                if (res.success) {
                    $('[data-StateCode-select]').find('option').remove();
                    res.data.forEach(item => {
                        const $option = $('<option/>', { value: item.Value, text: item.Text, });
                        if (!stateCode || item.Value === stateCode) {
                            $($option).attr('selected', 'selected');
                        }
                        $('[data-StateCode-select]').append($option);
                    });

                    if (stateCode) {
                        $('[data-StateCode-select]').val(stateCode).trigger('change');
                    }
                }
            },
            { contentType: 'application/json', addCulturInfo: true, silent: true }
        );
    }

    ManageStateCode(e) {
        const selectedValue = e.currentTarget.value;
        const element = $(e.currentTarget).find(`option[value="${selectedValue}"]`);
        element.attr('selected', 'selected');

        $('#StateCode').val(selectedValue);
        $('#StateCodeText').val(element.text().trim());
    }

    ManageCleanFields() {
        this.CleanValidators();

        //Empty all fields
        $(this._parentId).find(':input').each((_, field) => {
            $(field).val('');
        });

        $('[data-CountryCode-select]').val('').trigger('change');
        $('[data-StateCode-select]').val('').trigger('change');
    }

    CleanValidators() {
        $(this._parentId).find('[data-validator]').each((_, validator) => {
            $(validator).removeClass(this._validClass);
            $(validator).removeClass(this._invalidClass);
        });
    }

    ManageSetNonResident(e) {
        this.CleanValidators();
        const checked = $(e.currentTarget).is(":checked");
        $('#VatCode').val(checked ? this._defaultCnp : '');
        $('#VatCode').prop("readonly", checked);

        if (checked) {
            $('[data-check-vat-code-button]').attr('disabled', 'disabled');
        }
        else {
            $('[data-check-vat-code-button]').removeAttr('disabled');
        }

        this.ManageRenderInputDivs(this._hasData || checked);
        this.ManagePortletHeaderInfo(true, null);
    }

    ManageCheckButton() {
        this.CleanValidators();
        const personType = $('#PersonType').val();
        const vatCode = $('#VatCode').val();

        this.axLoading.ShowLoadingIndicator($(this._parentId)?.get(0));
        AxessViewer.loadPartialView(this._validateUrl,
            JSON.stringify({ personType: personType, vatCode: vatCode }),
            (res) => {
                this.axLoading.HideLoadingIndicator($(this._parentId)?.get(0));
                $('[data-validator="VatCode"]').toggleClass(this._validClass, res.success);
                $('[data-validator="VatCode"]').toggleClass(this._invalidClass, !res.success);
                this.ManageRenderInputDivs(this._hasData || res.success);
                this.ManagePortletHeaderInfo(res.success, res.errorMsg);
            },
            { contentType: 'application/json', addCulturInfo: true, silent: true }
        );
    }

    ManageContinueButton() {
        this.CleanValidators();
        if (!this.CheckRequiredFields()) {
            return;
        }
        const skipCodeValidation = $('#PersonType').val() === PersonType.Person.toString() && $('#SetNonResident').is(":checked");
        this.axLoading.ShowLoadingIndicator($(this._parentId)?.get(0));
        AxessViewer.loadPartialView(this._submitUrl,
            JSON.stringify({ jsonData: this.SerializeForm(), skipFiscalPayerCode: skipCodeValidation }),
            (res) => {
                this.axLoading.HideLoadingIndicator($(this._parentId)?.get(0));
                this.ManagePortletHeaderInfo(res.success, res.errorMsg);
                if (res.success) {
                    $('#kt_portlet__fiscal_data').addClass('kt-portlet__check');
                    //@ts-ignore
                    FiscalizationContinue();
                }
                else {
                    this.ManageInvalidFields(res.invalidFields);
                }
            },
            { contentType: 'application/json', addCulturInfo: true, silent: true }
        );
    }

    CheckRequiredFields() {
        let isValid = true;

        const personType = $('#PersonType').val();
        if (personType === '') {
            return false;
        }

        $(this._parentId).find('[data-address-inputs] input').each((_, field) => {
            isValid &&= $(field).val() != '';
        });

        $(this._parentId).find('[data-miscelanea-inputs] input').each((_, field) => {
            isValid &&= $(field).val() != '';
        });

        const dataSelector = personType === PersonType.Person.toString()
            ? '[data-person-inputs]'
            : '[data-company-inputs]';

        $(this._parentId).find(`${dataSelector} input`).each((_, field) => {
            isValid &&= $(field).val() != '';
        });

        return isValid;
    }

    SerializeForm() {
        var formdata = JSON.parse(JSON.stringify($(this._parentId).find('form').find('input:not(.noSerializable)').serializeArray()));
        var data = {};
        $(formdata).each(function (_, obj) {
            data[obj.name] = obj.value;
        });

        return JSON.stringify(data);
    }

    ManageInvalidFields(invalidFields) {
        if (invalidFields) {
            this.CleanValidators();
            $(this._parentId).find('[data-validator]').each((_, validator) => {
                $(validator).addClass(invalidFields.some(x => $(validator).attr('data-validator') === x)
                    ? this._invalidClass
                    : this._validClass);
            });
        }
    }

    ManagePortletHeaderInfo(success, errorMessage) {
        $('.fiscal-data-portlet__head__error').html(success ? '' : errorMessage);
        $('#kt_portlet__fiscal_data').toggleClass('kt-portlet__fail', !success);
    }
}

export enum PersonType {
    Person = "Person",
    Company = "Company"
}
export interface InitFiscalisationData {
    hasAccount: boolean;
    fiscalisationData : any
}